import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="We'll send a recovery link to your email."
      footer={<Link to="/login" className="text-[#4da6ff] hover:underline">Back to sign in</Link>}
    >
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-success">
          <CheckCircle2 className="w-10 h-10 text-[#4da6ff] mx-auto mb-3" />
          <p className="text-zinc-300 text-sm">If that email exists, a reset link is on its way. Check the server logs in this demo environment.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2">{error}</div>}
          <input data-testid="forgot-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full field px-4 py-3" />
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full bg-[#4da6ff] hover:bg-[#7ab8ff] text-white font-medium rounded-full py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
          </button>
        </form>
      )}
    </AuthShell>
  );
}
